import Vue from 'vue';

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el._clickOutsideHandler = function clickOutsideHandler(event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el._clickOutsideHandler);
  },
  unbind(el) {
    document.body.removeEventListener('click', el._clickOutsideHandler);
    delete el._clickOutsideHandler;
  },
});
